





























import { Component, Mixins } from "vue-property-decorator";
import { Department } from "../../../../domain/department";
import {
  ModelEditableMixin,
  IDialogCondition,
  DateTimePicker,
  DialogSelector,
  ISingleSelectableAsynchronously,
  ISingleSelectableConditionallyAsynchronously,
} from "../../../system";
import { DocumentAttributesEditableMixin } from "../mixins";
import { DepartmentFeatureAccessibleMixin } from "../../../department/mixins";
import { IDepartmentDialogCondition } from "../../../department/dialogs";

@Component({
  components: {
    DateTimePicker,
    DialogSelector,
  },
})
export default class DocumentAttributesEditor extends Mixins(
  ModelEditableMixin,
  DocumentAttributesEditableMixin,
  DepartmentFeatureAccessibleMixin,
) {
  get isEditable(): boolean {
    return this.readPropertyOrDefault(s => s.isAlreadyInitialized, false);
  }

  get isCreatedDateEnable(): boolean {
    return this.$configuration.behavior.document.editor.documentAttributes.createdDate.isEnable;
  }

  get createdDate(): Date {
    return this.attributes
      ? this.attributes.createdDate
      : undefined;
  }

  set createdDate(source: Date) {
    this.writeProperty(s => s.attributes.createdDate = source);
  }

  get department(): Department {
    return this.attributes
      ? this.attributes.department
      : undefined;
  }

  set department(source: Department) {
    this.writeProperty(s => s.attributes.department = source);
  }

  get departmentName(): string {
    return !this.department
      ? ""
      : this.department.name;
  }

  get departmentCondition(): IDepartmentDialogCondition {
    return {
      name: this.$wording.common.department + "属性",
      departmentGroup: this.$configuration.behavior.document.editor.departmentGroup.shouldIgnoreDepartmentGroupFilter ? null : undefined,
    };
  }

  get departmentDialog(): ISingleSelectableAsynchronously<Department> & ISingleSelectableConditionallyAsynchronously<Department, IDialogCondition> {
    return this.$commonDialogs.department.buttonSelector;
  }

  get shouldSendToHis(): boolean {
    return this.attributes && this.attributes.shouldSendToHis !== null && this.attributes.shouldSendToHis !== undefined;
  }

  get hisIndication(): string {
    const destinationName = this.$configuration.wording.document.editor.destinationNameForSendIndicator;
    const description = this.attributes && this.attributes.shouldSendToHis
      ? "送信対象"
      : "送信対象外";
    return destinationName + description;
  }
}
